import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";
import { Input } from "./ui/input";

/**
 * Parol maydoni — ko'rsatish/yashirish (ko'z) tugmasi bilan. Asosiy `Input`
 * adornment'ni qo'llab-quvvatlamagani uchun nisbiy konteyner + absolyut tugma.
 */
export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">
>(({ className, disabled, ...props }, ref) => {
  const { t } = useTranslation("common");
  const [show, setShow] = React.useState(false);

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        disabled={disabled}
        className={cn("pr-9", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        disabled={disabled}
        tabIndex={-1}
        aria-label={t(show ? "actions.hidePassword" : "actions.showPassword")}
        title={t(show ? "actions.hidePassword" : "actions.showPassword")}
        className="absolute right-0 top-0 flex h-9 w-9 items-center justify-center rounded-r-md text-muted-foreground transition-colors hover:text-foreground disabled:opacity-50"
      >
        {show ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
